import React, { useMemo, useRef } from "react";
import { Button, Form, Icon } from "antd";

const RepeatingFields = ({ form, renderOneItem, formKey, addButtonText, label }) => {
  const idRef = useRef(1);
  const allFieldsKeys = form.getFieldValue(formKey);

  const add = () => {
    const keys = form.getFieldValue(formKey);
    const nextKeys = keys.concat(idRef.current++);
    form.setFieldsValue({
      [formKey]: nextKeys,
    });
  };
  const deleteItem = (k) => {
    const keys = form.getFieldValue(formKey);
    if (keys.length === 1) {
      return;
    }
    form.setFieldsValue({
      [formKey]: keys.filter(key => key !== k),
    });
  }
  const allowDelete = useMemo(() => {
    if (allFieldsKeys.length > 1) {
      return true;
    } else return false;
  }, [allFieldsKeys?.length]);

  return (
      <Form.Item label={label}>
        {allFieldsKeys.map((index) => {
          return renderOneItem(index, allowDelete, deleteItem);
        })}
        <Button type="link" style={{color: "#888888", padding: "0px"}} onClick={() => add()}>
          <Icon type="plus-circle" style={{ color: "#09A2F2" }}/>
          {addButtonText}
        </Button>
      </Form.Item>
  )
}

export default RepeatingFields;